import { useEffect } from "react";

const updateTitle = () => {
  const hash = window.location.hash;
  const path = hash.replace("#", "");

  if (path.startsWith("/volkstotal")) {
    document.title = "Volks|Total";
  } else if (path.startsWith("/trucker-pay-gestor")) {
    document.title = "Trucker|Pay Gestor";
  } else {
    document.title = "Trucker|Pay Gestor";
  }
};

const PageTitle = () => {
  useEffect(() => {
    updateTitle();

    const handleHashChange = () => {
      updateTitle();
    };

    window.addEventListener("hashchange", handleHashChange);

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);

  return null;
};

export default PageTitle;
